import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { ITenantNotification } from './interfaces';

export const getTenantNotification = (config?: AxiosRequestConfig) => {
  return instance()
    .get<ITenantNotification | void>(`/notification/tenant`, config)
    .then((response) => response.data);
};

export const checkTenantNotification = (notificationId: number) => {
  return instance()
    .post(`/notification/tenant/${notificationId}`)
    .then((response) => response.data);
};
